module.exports = __webpack_public_path__ + "media/images/icon-point-dark-blue-e0921ebe3927871a2448ca535fb374f3.svg";